module.exports = __webpack_public_path__ + "img/worksbot_img19122405.52985a0d.jpg";